import React from "react";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";
const Protected = ({ children }) => {
  const token = Cookies.get("token");
  return token ? children : <Navigate to="/" replace />;
};

export default Protected;
